import React, { useState, useEffect } from 'react';
import { apiHolder, api, apis } from 'api';
import classNames from 'classnames';
import { SimpleAvatar } from './avatar';
import { ReactComponent as IconExpand } from '@/images/icons/sidebar/icon-expand.svg';
import { ReactComponent as IconShrink } from '@/images/icons/sidebar/icon-shrink.svg';
import { ReactComponent as AddAcountIcon } from '@/images/icons/sidebar/add-account.svg';
import { Tooltip } from 'antd';
import useRisk from '@web-common/hooks/useRisk';
import Message from '@web-common/components/UI/Message/SiriusMessage';
const loginApi = api.requireLogicalApi(apis.loginApiImpl);
import style from './avatar-list.module.scss';
import { useAppDispatch, useAppSelector } from '@web-common/state/createStore';
import { doListAccountsAsync, doSwitchAccountAsync, doSwitchMobileAccountAsync, doSwitchSharedAccountAsync, doSharedAccountAsync, } from '@web-common/state/reducer/loginReducer';
import { getIn18Text } from 'api';
import { useEventObserver } from '@web-common/hooks/useEventObserver';
const systemApi = apiHolder.api.getSystemApi();
const mailApi = apiHolder.api.requireLogicalApi(apis.mailApiImpl);
const accountApi = api.requireLogicalApi(apis.accountApiImpl);
const inElectron = systemApi.isElectron;
const isMac = inElectron() ? window.electronLib.env.isMac : apiHolder.env.isMac;
export const AvatarList = ({ isBlock, onBlock }) => {
    const dispatch = useAppDispatch();
    const { riskManage } = useRisk();
    const [list, setList] = useState([]);
    const [expanding, setExpanding] = useState(false);
    const [maxHeight, setMaxHeight] = useState(100);
    const [blurBg, setBlurBg] = useState(false);
    const [addAccountVisible, setAddAccountVisible] = useState(false);
    const { localList, mobileList } = useAppSelector(state => state.loginReducer.accountList);
    const { sharedAccount } = useAppSelector(state => state.loginReducer);
    const switchingAccount = useAppSelector(state => state.loginReducer.switchingAccount);
    const currentMail = useAppSelector(state => state.mailReducer.currentMail);
    const [sideBarAccountUnreadStatus, setSideBarAccountUnreadStatus] = useState({});
    const [moreAccountListHasUnread, setMoreAccountListHasUnread] = useState(false);
    const mobileTrans = (arr) => arr.map(item => ({
        id: item.id,
        email: item.accountId,
        avatar: item.avatar,
        name: item.nickName,
        isMobileBindAccount: true,
        unread: !!sideBarAccountUnreadStatus[item.id],
    }));
    const localTrans = (arr) => {
        const accounts = [];
        if (sharedAccount.isSharedAccountLogin) {
            accounts.push({
                id: sharedAccount.email,
                email: sharedAccount.email,
                avatar: '',
                name: sharedAccount.nickName,
                isSharedAccount: !sharedAccount.isSharedAccountExpired ? true : false,
                unread: !!sideBarAccountUnreadStatus[sharedAccount.email],
            });
        }
        arr.forEach(item => {
            if (!item.expired) {
                accounts.push({
                    id: item.id,
                    email: item.id,
                    avatar: item.avatar,
                    name: item.nickName,
                    isSharedAccount: sharedAccount.isSharedAccountLogin ? sharedAccount.email === item.id : false,
                    unread: !!sideBarAccountUnreadStatus[item.id],
                });
            }
        });
        return accounts;
    };
    const tranSharedAccount = (sharedAccounts) => {
        if (!sharedAccounts || !sharedAccounts.length) {
            return [];
        }
        return sharedAccounts
            .filter(item => {
            return !item.isCurrentAccount;
        })
            .map(item => {
            return {
                id: item.email,
                email: item.email,
                avatar: item.avatar,
                name: item.nickName,
                isSharedAccount: true,
                unread: !!sideBarAccountUnreadStatus[item.email],
            };
        });
    };
    useEffect(() => {
        if (process.env.BUILD_ISPREVIEWPAGE)
            return;
        dispatch(doListAccountsAsync(false));
        dispatch(doSharedAccountAsync());
    }, []);
    useEffect(() => {
        const accounts = [...tranSharedAccount(sharedAccount.sharedAccounts), ...localTrans(localList), ...mobileTrans(mobileList)];
        if (expanding) {
            setMaxHeight(process.env.BUILD_ISEDM ? '100%' : '87vh');
            setList(accounts);
            setBlurBg(true);
        }
        else {
            let mexHeight = 156;
            if (process.env.BUILD_ISEDM) {
                mexHeight = accounts.length === 0 ? 58 : 12;
            }
            setMaxHeight(mexHeight);
            const hiddenAccounts = accounts.slice(2);
            let hasUnread = false;
            hiddenAccounts.forEach(item => {
                if (!!item.unread) {
                    hasUnread = true;
                }
            });
            setMoreAccountListHasUnread(hasUnread);
            setTimeout(() => {
                setBlurBg(false);
                if (process.env.BUILD_ISEDM) {
                    setList(accounts.slice(0, 1).reverse());
                }
                else {
                    setList(accounts.slice(0, 2).reverse());
                }
            }, 300);
        }
    }, [expanding, localList, mobileList, sharedAccount, sideBarAccountUnreadStatus]);
    process.env.BUILD_ISELECTRON &&
        useEventObserver('accountNotify', {
            name: 'accountNotifyAsync',
            func: () => {
                accountApi.getSidebarDockAccountList().then(res => {
                    setSideBarAccountUnreadStatus(res);
                });
                dispatch(doListAccountsAsync());
            },
        });
    const handleLogin = (user) => {
        if (switchingAccount) {
            return;
        }
        if (isBlock) {
            onBlock && onBlock();
            return;
        }
        if (user.isMobileBindAccount) {
            dispatch(doSwitchMobileAccountAsync({ id: user.id, riskManage }));
        }
        else if (user.isSharedAccount) {
            dispatch(doSwitchSharedAccountAsync(user.email));
        }
        else {
            dispatch(doSwitchAccountAsync(user.email));
        }
    };
    const handleSwitchAccount = async (user) => {
        currentMail &&
            mailApi
                .doSaveTemp({ content: currentMail, saveDraft: true })
                .then(res => console.log(getIn18Text('BAOCUNCHENGGONG'), res))
                .catch(error => {
                console.log(getIn18Text('BAOCUNCAOGAOSHI'), error);
            });
        handleLogin(user);
    };
    const handleAddAccount = () => {
        if (switchingAccount) {
            Message.info({ content: getIn18Text('QIEHUANZHANGHAOZHONG') });
            return;
        }
        loginApi.showCreateAccountPage();
    };
    const hasMoreAccount = [...tranSharedAccount(sharedAccount.sharedAccounts), ...localTrans(localList), ...mobileTrans(mobileList)].length > (process.env.BUILD_ISEDM ? 0 : 2);
    const visibleExpandIcon = !expanding && hasMoreAccount;
    useEffect(() => {
        if (!hasMoreAccount) {
            setAddAccountVisible(true);
        }
        if (hasMoreAccount) {
            if (expanding) {
                setAddAccountVisible(true);
            }
            else {
                setTimeout(() => {
                    setAddAccountVisible(false);
                }, 200);
            }
        }
    }, [hasMoreAccount, expanding]);
    const noOtherAccount = !list || !list.length;
    const VisibleExpandIconEle = (React.createElement("div", { className: style.floatBtn, onClick: e => {
            e.preventDefault();
            e.stopPropagation();
            setExpanding(true);
        } },
        React.createElement(IconExpand, null),
        moreAccountListHasUnread && React.createElement("div", { className: style.avatarRedDot })));
    const AddAccountEle = () => {
        let marginBottom = 0;
        if (noOtherAccount) {
            marginBottom = process.env.BUILD_ISEDM ? 12 : 16;
        }
        return addAccountVisible ? (React.createElement("div", { className: style.addAccountWrapper, style: { marginBottom } },
            React.createElement(Tooltip, { title: getIn18Text('addEnterpriseAccount'), placement: "right" },
                React.createElement("div", { className: style.addAccountIcon, onClick: handleAddAccount },
                    React.createElement(AddAcountIcon, null))))) : (React.createElement(React.Fragment, null));
    };
    const ListEle = list.map(user => (React.createElement(SimpleAvatar, { isSwitching: switchingAccount === (user === null || user === void 0 ? void 0 : user.email), showRedDot: user === null || user === void 0 ? void 0 : user.unread, key: user === null || user === void 0 ? void 0 : user.email, user: user, onClick: () => handleSwitchAccount(user) })));
    const FloatBtn = expanding ? (React.createElement("div", { className: style.floatBtn, onClick: e => {
            e.preventDefault();
            e.stopPropagation();
            setExpanding(false);
        }, style: { position: 'static' } },
        React.createElement(IconShrink, null))) : (React.createElement(React.Fragment, null));
    return (React.createElement("div", { "data-test-id": "pc-sidebar-avatar-list", className: classNames(style.avatarList, {
            [style.blurBg]: blurBg,
            [style.avatarListEdm]: process.env.BUILD_ISEDM,
            [style.avatarListEdmMac]: process.env.BUILD_ISEDM && isMac,
        }) },
        visibleExpandIcon && VisibleExpandIconEle,
        React.createElement("div", { className: classNames(style.scrollWrapper, { [style.hasVisibleAddAccount]: !hasMoreAccount }), style: { maxHeight } },
            React.createElement("div", { className: style.listContent },
                FloatBtn,
                AddAccountEle(),
                React.createElement("div", { className: style.listWrapper }, ListEle)))));
};
